import "./gtakList.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import GtakTable from "../gtaktable/GtakTable";

const GtakList = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <GtakTable />
      </div>
    </div>
  );
};

export default GtakList;
